import React from "react";
import { Link, useLocation } from "react-router-dom";

import Logo from "../../assets/Logo.svg";
import Fb from "../../assets/FB.svg";
import Instagram from "../../assets/Instagram.svg";
import Linkedin from "../../assets/Linkedin.svg";
import SuccessImage from "../../assets/success.png";
import Error from "../../assets/error.svg";
import useFooter from "../../hooks/useFooter";
import { InviteFriendModal, Success } from "../../modals";
import Envelope from "../../assets/InviteFriendEnvelope.png";

import "./Footer.scss";

const Footer = () => {
  const {
    isModalOpened,
    closeModal,
    openModal,
    inviteObj,
    email,
    handleInput,
    subsCribe,
    isSuccessModalOpened,
    closeSuccessModal,
    openSuccessModal,
    checkEmail,
    showError,
    emailError,
  } = useFooter();
  const { pathname } = useLocation();
  if (
    pathname.includes("signup") ||
    pathname.includes("signin") ||
    pathname.includes("forgotpassword") ||
    pathname.includes("scenario") ||
    pathname.includes("profile")
  ) {
    return <></>;
  }
  return (
    <footer className="Footer">
      <div className="Footer-email">
        <div className="Footer-email-inner">
          <p className="Footer-email__content">Stay in touch</p>
          <input
            placeholder="Email"
            className="Footer-email__input"
            value={email}
            onChange={handleInput}
          />
          <button
            className="Footer-email__button"
            onClick={() => {
              checkEmail(email);
            }}
          >
            Subscribe
          </button>
        </div>
        {showError ? (
          <div className="errorCont">
            <img src={Error} alt="Error" />
            <p className="errorCont__text">{emailError}</p>
          </div>
        ) : null}
      </div>
      <div className="Footer-container">
        <div className="Footer-container-content">
          <div className="Footer-container-content__info">
            <div className="Footer-container-content__info__logo">
              <img src={Logo} alt="" />
            </div>
            <p>
              We help young people build clarity, confidence, and direction for what comes next.
            </p>
          </div>
          {/* <div className="Footer-container-content__product">
            <p className="Footer-container-content__product__title">Product</p>
            <p className="Footer-container-content__product__item">Resources</p>
            <p className="Footer-container-content__product__item">Pricing</p>
            <p className="Footer-container-content__product__item">Reviews</p>
          </div> */}
          <div className="Footer-container-content__company">
            <p className="Footer-container-content__company__title">Company</p>
            <p className="Footer-container-content__company__item">
              <Link to="/about">About</Link>
            </p>
            <p
              className="Footer-container-content__company__item"
              onClick={() => {
                openModal("CONTACT");
              }}
            >
              Contact us
            </p>
            <p className="Footer-container-content__company__item">
              <Link to="/stories">Stories</Link>
            </p>
          </div>
          <div className="Footer-container-content__support">
            <p className="Footer-container-content__support__title">Support</p>
            <p
              className="Footer-container-content__support__item"
              onClick={() => {
                openModal("CHAT");
              }}
            >
              Chat support
            </p>
            <p
              className="Footer-container-content__support__item"
              onClick={() => {
                openModal("BUG");
              }}
            >
              Report a bug
            </p>
            <p className="Footer-container-content__support__item">
              <Link to="/faq">FAQ</Link>
            </p>
          </div>
          <div className="Footer-container-content__followus">
            <p className="Footer-container-content__followus__title">
              Follow us
            </p>
            <div className="Footer-container-content__followus__icons">
              <div className="Footer-container-content__followus__icons__img">
                <a
                  target="_blank"
                  href="https://www.facebook.com/profile.php?id=100092435600745"
                  rel="noreferrer"
                >
                  <img src={Fb} alt="" />
                </a>
              </div>
              <div className="Footer-container-content__followus__icons__img">
                <a
                  target="_blank"
                  href="https://www.instagram.com/careerscoops/"
                  rel="noreferrer"
                >
                  <img src={Instagram} alt="" />
                </a>
              </div>
              <div className="Footer-container-content__followus__icons__img">
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/career-scoops/?viewAsMember=true"
                  rel="noreferrer"
                >
                  <img src={Linkedin} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="Footer-container-line" />
        <div className="Footer-container-copyright">
          <p>
            Copyright © 2026 Career Scoops® | All Rights Reserved |{" "}
            <Link to="/terms">Terms and Conditions</Link> |{" "}
            <Link to="/privacypolicy">Privacy Policy</Link>
          </p>
        </div>
      </div>
      <InviteFriendModal
        isOpened={isModalOpened}
        closeModal={closeModal}
        text={inviteObj.text}
        title={inviteObj.title}
        type={inviteObj.type}
        leftBtnText="Cancel"
        rightBtnText="Send"
        img={Envelope}
        from="Home"
      />
      <Success
        isOpened={isSuccessModalOpened}
        close={closeSuccessModal}
        title="success"
        text="Check your Email"
        image={SuccessImage}
      />
    </footer>
  );
};

export default Footer;
